/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApproveProjectCommand } from '../../models/approve-project-command';
import { ApproveProjectCommandResult } from '../../models/approve-project-command-result';

export interface ApiProjectApproveProjectByManagerPatch$Plain$Params {
      body?: ApproveProjectCommand
}

export function apiProjectApproveProjectByManagerPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectApproveProjectByManagerPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectApproveProjectByManagerPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApproveProjectCommandResult>;
    })
  );
}

apiProjectApproveProjectByManagerPatch$Plain.PATH = '/api/Project/ApproveProjectByManager';
